import React from 'react';
import { Search, Filter, SlidersHorizontal, Download, Keyboard, Clock, Calendar, ChevronDown } from 'lucide-react';
export function SearchBar() {
  const quickFilters = [{
    label: 'Overdue',
    icon: Clock,
    active: false
  }, {
    label: 'Today',
    icon: Calendar,
    active: true
  }, {
    label: 'Upcoming',
    icon: Clock,
    active: false
  }, {
    label: 'This Week',
    active: false
  }, {
    label: 'This Month',
    active: false
  }];
  const dropdownFilters = [{
    label: 'All Categories',
    icon: Filter
  }, {
    label: 'All Status'
  }, {
    label: 'All Billing'
  }, {
    label: 'All Members'
  }, {
    label: ''
  }, {
    label: 'Next Billing ↑'
  }];
  return <div className="bg-[#1a1a1a] rounded-t-xl border border-[#252525] border-b-0" data-id="element-40">
      {/* Search and Actions Bar */}
      <div className="flex items-center justify-between px-6 py-4" data-id="element-41">
        <div className="flex items-center gap-4 flex-1" data-id="element-42">
          <div className="flex items-center gap-3 flex-1 max-w-md" data-id="element-43">
            <Search size={18} className="text-gray-500" data-id="element-44" />
            <input type="text" placeholder="Search subscriptions..." className="bg-transparent border-none outline-none text-sm text-white placeholder-gray-600 flex-1" data-id="element-45" />
            <button className="text-gray-500 hover:text-gray-400 transition-colors" data-id="element-46">
              <Filter size={18} data-id="element-47" />
            </button>
          </div>
        </div>

        <div className="flex items-center gap-3" data-id="element-48">
          <button className="flex items-center gap-2 px-4 py-2 rounded-lg border border-[#333333] text-sm text-gray-400 hover:text-white hover:border-gray-600 transition-all" data-id="element-49">
            <SlidersHorizontal size={16} data-id="element-50" />
            Table Options
          </button>
          <button className="flex items-center gap-2 px-4 py-2 rounded-lg border border-[#333333] text-sm text-gray-400 hover:text-white hover:border-gray-600 transition-all" data-id="element-51">
            <Download size={16} data-id="element-52" />
            Export
          </button>
          <button className="flex items-center gap-2 px-4 py-2 rounded-lg border border-[#333333] text-sm text-gray-400 hover:text-white hover:border-gray-600 transition-all" data-id="element-53">
            <Keyboard size={16} data-id="element-54" />
            Keyboard Shortcuts
          </button>
        </div>
      </div>

      {/* Quick Filters */}
      <div className="flex items-center gap-2 px-6 pb-4" data-id="element-55">
        {quickFilters.map((filter, index) => {
        const Icon = filter.icon;
        return <button key={index} className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm transition-all ${filter.active ? 'bg-[#252525] text-white' : 'text-gray-600 hover:text-gray-400 hover:bg-[#1a1a1a]'}`} data-id="element-56">
              {Icon && <Icon size={14} data-id="element-57" />}
              {filter.label}
            </button>;
      })}
      </div>

      {/* Dropdown Filters */}
      <div className="flex items-center gap-3 px-6 pb-4" data-id="element-58">
        {dropdownFilters.map((filter, index) => <button key={index} className={`flex items-center gap-2 px-4 py-2 rounded-lg border border-[#333333] text-sm text-gray-400 hover:text-white hover:border-gray-600 transition-all ${!filter.label ? 'w-12' : ''}`} data-id="element-59">
            {filter.icon && <filter.icon size={14} data-id="element-60" />}
            {filter.label}
            {filter.label && <ChevronDown size={14} data-id="element-61" />}
          </button>)}
      </div>
    </div>;
}